type CurrencyOptions = {
  type?: string;
  locale?: string;
};

export function currency(
  amount: string | number,
  options?: CurrencyOptions,
): string {
  const { type = "USD", locale } = options || {};

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: type,
  }).format(parseFloat(String(amount)));
}
